declare var require: any;

export const environment = {
  production: true,
  env: 'prop',
  mapbox: {
    accessToken: 'pk.eyJ1Ijoic29sYXJuZXQ3IiwiYSI6ImNrYnF5OGZwbjJyMWYycnB2aW12c2duengifQ.Aevgur_5g0-ceyWU2a4yCw'
  },
  onesignalAppId: '5ae84a18-73f2-4812-90ce-dd5f109addd6',

  smartAlarmsHost: 'https://va-prop-smart-alarms.oplaenergy.org',
  authHost: 'https://va-prop-oauth.oplaenergy.org',
  host: 'https://va-prop-cms.oplaenergy.org',
  tableHost: 'https://va-prop-generic-opla-tables.oplaenergy.org',
  streamHost: 'https://va-prop-live-drillingparams.oplaenergy.org',
  hostHistory: 'https://va-prop-drillingparams.oplaenergy.org',

  eventHost: 'https://va-prop-opla-events.oplaenergy.org',

  mpdsCrud: 'https://va-prop-cms.oplaenergy.org/mpds-crud-service',

  chatHost: 'https://va-prod-chatting-crud-crud-producer.oplaenergy.org/opla-job-chatting-producer-service',
  chatHistory: 'https://va-prod-historical-cruf-chatting.oplaenergy.org/opla-job-crud-chatting',

  reportHost: 'https://va-prop-auto-daily-report.oplaenergy.org',

  rcdBearing: 'https://va-prop-rcdbearings-table.oplaenergy.org/rcdbearings-crud-service',
  rcdTracking: 'https://va-prop-rcdtracking.oplaenergy.org/rcdtracking-crud-microservice',

  dailyOperationCrudService: 'https://va-prop-dailyoperations.oplaenergy.org/daily-operations-crud-service',

  surgeSwabService: 'https://va-prop-surgeswabsettings-table.oplaenergy.org/surgeSwabSettings-crud-service',

  aggregationService: 'https://va-prop-influxdb-windowing-microservice.oplaenergy.org/influxdb-windowing-microservice',
  wellAccessService: 'https://va-prop-well-access-service.oplaenergy.org/opla-well-access-service',

  oplaManagementService: 'https://va-prop-opla-mgmt-service.oplaenergy.org/opla-user-well-managment-service',

  nodeServer: 'https://live.oplaenergy.com',
  oplaCms: 'https://cms.oplaenergy.com',
  xApiKey: 'a4d3198d-c08a-48a7-85d4-776a640264e9',

  version: require('../../package.json').version
};
